
export default {
  methods: {
    formatPhoneNumberTextField (phone) {
      let digitsOnly = phone.replace(/\D/g, '');
      if (digitsOnly.length > 11) {
        digitsOnly = digitsOnly.slice(0, 11);
      }

      let formattedNumber = '+7';
      if (digitsOnly.length > 1) {
        formattedNumber += '(' + digitsOnly.slice(1, 4);
      }

      if (digitsOnly.length > 4) {
        formattedNumber += ')' + digitsOnly.slice(4, 7);
      }

      if (digitsOnly.length > 7) {
        formattedNumber += '-' + digitsOnly.slice(7, 9);
      }

      if (digitsOnly.length > 9) {
        formattedNumber += '-' + digitsOnly.slice(9, 11);
      }

      phone = formattedNumber.replace(/--/g, '-');

      if (phone.endsWith('-')) {
        phone = phone.slice(0, -1);
      }

      return formattedNumber;
    },
  },
};
